import { Injectable } from '@angular/core';


@Injectable({
  providedIn: 'root'
})
export class IndexedDBService {

   private dbName = 'TaskManagerDB';
  private storeName = 'task';
  private db!: IDBDatabase;
  public userDetail:any;
  constructor() {
   this.initDB();
  }
  initDB() {

    const request = indexedDB.open(this.dbName, 1);
    request.onupgradeneeded = (event: any) => {
      this.db = event.target.result;
      if (!this.db.objectStoreNames.contains(this.storeName)) {
        const objectStore = this.db.createObjectStore(this.storeName, {keyPath: 'email',autoIncrement:true});
        // Indexes
        objectStore.createIndex("email", "email", { unique: true });
      }
    };
    request.onsuccess = (event: any) => {
      this.db = event.target.result;
    // const objectStore = this.db.createObjectStore(this.storeName);



      // console.log('Database initialized successfully');
    };
    request.onerror = (event:any) => {
      console.error('Error initializing database:', event.target.error);
    };
  }
  addData(data: any): Promise<number> {
    return new Promise((resolve, reject) => {
      const transaction = this.db.transaction(this.storeName, 'readwrite');
      const store = transaction.objectStore(this.storeName);
      const request = store.add(data);
     // request.onsuccess = () => resolve(request.result as number);
      request.onsuccess = () => resolve(request.result as number);
      request.onerror = () => reject(request.error);
    });
  }
  getAllData(): Promise<any[]> {
    return new Promise((resolve, reject) => {
      const transaction = this.db.transaction(this.storeName, 'readonly');
      const store = transaction.objectStore(this.storeName);
      const request = store.getAll();
      request.onsuccess = () => resolve(request.result);
      request.onerror = () => reject(request.error);
    });
  }

  getData(taskId:any):Promise<any>{
    return new Promise((resolve, reject) => {
      const transaction = this.db.transaction(this.storeName, 'readwrite');
      const store = transaction.objectStore(this.storeName);
     let getRequest = store.get(taskId);
      getRequest.onsuccess = function(event:any) {
         let task = event.target.result;
         resolve(task);
      }




      getRequest.onerror = ()=>reject(getRequest.error);



    });
  }

  updateData(taskId, data): Promise<void> {

    return new Promise((resolve, reject) => {
      const transaction = this.db.transaction(this.storeName, 'readwrite');
      const store = transaction.objectStore(this.storeName);
     let getRequest = store.get(taskId);
      getRequest.onsuccess = function(event:any) {
    let task = event.target.result;
    if (task) {
      task.section = data;
      let updateRequest = store.put(task);

      updateRequest.onsuccess = (event:any) => {
        // Task updated successfully
        resolve(event.target.result);
      };

      updateRequest.onerror = ()=>reject(updateRequest.error);
    }
   }

    });
  }
  deleteData(key: any): Promise<void> {
    return new Promise((resolve, reject) => {
      const transaction = this.db.transaction(this.storeName, 'readwrite');
      const store = transaction.objectStore(this.storeName);
      const request = store.delete(key);
      request.onsuccess = () => resolve();
      request.onerror = () => reject(request.error);
    });
  }


  clearAll():Promise<void>{
    return new Promise((resolve,reject)=>{
      const transaction = this.db.transaction(this.storeName, 'readwrite');
      const store = transaction.objectStore(this.storeName);
      const request = store.clear();
      request.onsuccess = () => resolve();
      request.onerror = () => reject(request.error);
    })
  }

}
